import { PayloadAction, createSlice } from '@reduxjs/toolkit'

import { RootState } from '~/redux/store'
import { logout } from '~/auth/slices/auth.slice'

export interface CurriculumPersistType {
  activeCompetencyList: string[]
  scrollItemId: string
  curriculumName: string
}

const initialState: CurriculumPersistType = {
  activeCompetencyList: [],
  scrollItemId: '',
  curriculumName: '',
}

const slice = createSlice({
  name: 'persistCurriculum',
  initialState,
  reducers: {
    addActiveCompetency: (state, action: PayloadAction<string>) => {
      state.activeCompetencyList = [...state.activeCompetencyList, action.payload]
    },
    removeActiveCompetency: (state, action: PayloadAction<string>) => {
      state.activeCompetencyList = state.activeCompetencyList.filter((id) => id !== action.payload)
    },
    clearAndUpdateActiveCompetencyList: (state, action: PayloadAction<string>) => {
      state.activeCompetencyList = [action.payload]
    },
    setScrollItemId: (state, action: PayloadAction<string>) => {
      state.scrollItemId = action.payload
    },
    setCurriculumName: (state, action: PayloadAction<string>) => {
      state.curriculumName = action.payload
    },
  },
  extraReducers: (builder) => {
    builder.addCase(logout, (state) => {
      state.curriculumName = initialState.curriculumName
    })
  },
})
export const selectActiveCompetencyList = (state: RootState): CurriculumPersistType['activeCompetencyList'] =>
  state.persistCurriculum.activeCompetencyList

export const selectScrollItemIdOnTopicPage = (state: RootState): CurriculumPersistType['scrollItemId'] =>
  state.persistCurriculum.scrollItemId

export const selectCurriculumName = (state: RootState): CurriculumPersistType['curriculumName'] =>
  state.persistCurriculum.curriculumName

export const {
  addActiveCompetency,
  removeActiveCompetency,
  clearAndUpdateActiveCompetencyList,
  setScrollItemId: setScrollItemIdOnTopicPage,
  setCurriculumName,
} = slice.actions

export default slice.reducer
